import { render, staticRenderFns } from "./InfoAdditionalCost.vue?vue&type=template&id=4fba50a8&scoped=true"
import script from "./InfoAdditionalCost.vue?vue&type=script&lang=js"
export * from "./InfoAdditionalCost.vue?vue&type=script&lang=js"
import style0 from "./InfoAdditionalCost.vue?vue&type=style&index=0&id=4fba50a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba50a8",
  null
  
)

export default component.exports